import { Tag } from "antd";
import { ColumnsType } from "antd/es/table";
import "Features/Tenants/tenants.index.css";
import { Platform } from "Features/Users/redux/types";
import { ActionRenderer } from "./actionRenderer";
export const renderActiveStatus = (isActive: boolean) => 
  isActive ? <Tag color="green">Yes</Tag> : <Tag color="red">No</Tag>;

const getPlatformDisplayName = (platform: string): string => {
  switch (platform) {
    case Platform.TenantManagementPortal:
      return "Tenant Management Portal";
    case Platform.SelfServicePortal:
      return "Self Service Portal";
    default:
      return "Centerprise";
  }
};

export const columns: ColumnsType<any> = [
  {
    title: "Email",
    dataIndex: "emailAddress",
    key: "emailAddress",
    width: 600,
  },
  {
    title: "Active",
    dataIndex: "isLockedOut",
    key: "isLockedOut",
    render: (isLockedOut: boolean) => renderActiveStatus(!isLockedOut),
    width: 100,
  },
  {
    title: "Platform",
    dataIndex: "platform",
    key: "platform",
    align: "center",
    render: getPlatformDisplayName,
    width: 300,
  },
  {
    title: "Actions",
    dataIndex: "actions",
    key: "actions",
    width :"10%",
    align: "center",
    render: ActionRenderer,
  },
];
